import StudentRegistrationForm from "../StudentRegistrationForm";

export default function StudentRegistrationFormSection({
  sports,
  editingStudentId,
  onCancelEdit,
  onRegistered,
  sectionRef,
}) {
  return (
    <div
      ref={sectionRef}
      id="sr-registration"
      className="student-reg-panel"
      style={{ scrollMarginTop: "1rem" }}
    >
      <StudentRegistrationForm
        sports={sports}
        editingStudentId={editingStudentId}
        onCancelEdit={onCancelEdit}
        onRegistered={onRegistered}
      />
    </div>
  );
}
